import ImgWrapper from "../../../../../gatsby-theme-rpsych-therapist-effects/content/therapist-effects/intro/wrapper";
import * as React from 'react';
export default {
  ImgWrapper,
  React
};